// Mock data for Venura Consultants website

export const testimonials = [
  {
    id: 1,
    company: "SaaS Business",
    revenue: "~USD 185 Mn Deal Size",
    quote: "Venura transformed our financial reporting completely. The metric variance was reduced to less than 2% month-to-month, and our retention trends became consistent. Their work directly supported a ~40% increase in our final acquisition offer.",
    author: "CEO",
    industry: "SaaS",
    results: [
      "Metric variance reduced to <2%",
      "Retention trends became consistent",
      "~40% increase in final offer"
    ]
  },
  {
    id: 2,
    company: "Digital Performance Agency",
    revenue: "~USD 9 Mn Revenue",
    quote: "Working with Venura was a game-changer. Our EBITDA improved by 10-12% in just one quarter, and margin variance was cut by 50%. We finally have clear, client-level data that empowers our leadership to make confident decisions.",
    author: "Founder",
    industry: "Agency",
    results: [
      "EBITDA improved by ~10-12% in Q1",
      "Margin variance reduced by ~50%",
      "Clear client-level data visibility"
    ]
  },
  {
    id: 3,
    company: "D2C Ecommerce Brand",
    revenue: "~INR 200 Mn Revenue",
    quote: "Venura brought structure to our chaos. Inventory accuracy jumped 25-30%, return processing went from 12-18 days to just 3-5 days, and payout reconciliation time was slashed by 50%. Our operations run smoother than ever.",
    author: "Operations Director",
    industry: "E-commerce",
    results: [
      "Inventory accuracy improved by ~25-30%",
      "Returns processed in 3-5 days (was 12-18)",
      "Payout reconciliation time reduced by ~50%"
    ]
  },
  {
    id: 4,
    company: "Early-Stage SaaS",
    revenue: "~USD 300k ARR",
    quote: "As an early-stage startup, we needed reliable numbers and predictable timelines. Venura improved our burn accuracy by 25-30%, created periodic reports we could trust, and gave us the runway visibility we desperately needed.",
    author: "Co-Founder",
    industry: "Early-Stage SaaS",
    results: [
      "Burn accuracy improved by ~25-30%",
      "Reduced reconciliation time significantly",
      "Accurate runway planning achieved"
    ]
  }
];

export const services = [
  {
    id: 1,
    title: "Accounting & Compliance",
    description: "Reliable bookkeeping, financial statements, tax and regulatory filings that you can trust.",
    features: [
      "Complete accounting setup and maintenance",
      "Accurate revenue, expense, and tax entries",
      "Receivable, payable, and vendor ledgers tracked and reconciled",
      "Support for tax and statutory filings",
      "Audit-ready documentation"
    ]
  },
  {
    id: 2,
    title: "Reporting & Insights",
    description: "Management reports, investor packs, KPIs, dashboards, and automation that drive decisions.",
    features: [
      "Structured Management P&L, balance sheet, and cash flow reporting",
      "KPI tracking for revenue, margins, costs, and cash",
      "Automated report templates, models, and dashboards",
      "Reports aligned with management and investor needs",
      "Real-time visibility into business performance"
    ]
  },
  {
    id: 3,
    title: "Due Diligence",
    description: "Financial reviews, data room preparation, and investor Q&A support for fundraising or exits.",
    features: [
      "Preparation of financial and operational data packs",
      "Clean metric files (MRR, churn, cohorts, unit economics)",
      "Reconciliations, variance analyses, and supporting documents",
      "Data room setup and document organization",
      "Responses to investor or buyer queries"
    ]
  },
  {
    id: 4,
    title: "Operational Advisory",
    description: "Process design, cash flow management, controls, and decision frameworks that scale.",
    features: [
      "Process mapping across billing, approvals, payouts, and reconciliations",
      "Documented workflows, ownership, and control checks",
      "Basic automation to reduce manual effort",
      "Operational structure to reduce errors and delays",
      "Risk Control Metrics (RCMs) implementation"
    ]
  }
];

export const kpis = [
  { label: "Average EBITDA Improvement", value: "10-12%", period: "per quarter", icon: "trendingUp" },
  { label: "Metric Variance Reduction", value: "<2%", period: "month-to-month", icon: "target" },
  { label: "Reconciliation Time Saved", value: "50%", period: "average", icon: "clock" },
  { label: "Inventory Accuracy Gain", value: "25-30%", period: "within 90 days", icon: "checkCircle" },
  { label: "Processing Time Reduction", value: "3-5 days", period: "from 12-18 days", icon: "zap" },
  { label: "Burn Accuracy Improvement", value: "25-30%", period: "for early-stage", icon: "activity" }
];

export const tools = [
  { name: "QuickBooks", category: "Accounting" },
  { name: "Xero", category: "Accounting" },
  { name: "Power BI", category: "Analytics" },
  { name: "Microsoft Excel", category: "Analysis" },
  { name: "ERP Systems", category: "Enterprise" },
  { name: "MS Office Suite", category: "Productivity" },
  { name: "Tableau", category: "Visualization" },
  { name: "Google Workspace", category: "Collaboration" }
];

export const faqs = [
  {
    id: 1,
    question: "What types of businesses do you work with?",
    answer: "We work with SaaS businesses, digital agencies, D2C/ecommerce brands, early-stage startups, fintech & NBFCs, manufacturing & construction firms, and B2B/B2C companies across various industries."
  },
  {
    id: 2,
    question: "How long does an engagement typically last?",
    answer: "Engagements range from short reviews (2-4 weeks) to ongoing monthly support. We tailor the duration based on your specific needs, whether it's due diligence preparation, process overhaul, or continuous financial management."
  },
  {
    id: 3,
    question: "Do you work with international businesses?",
    answer: "Yes, we support businesses scaling globally. Our team has experience with multi-currency reporting, international tax considerations, and cross-border operational structures."
  },
  {
    id: 4,
    question: "What makes Venura different from traditional accounting firms?",
    answer: "We bridge technical finance and execution. Beyond compliance, we focus on building systems that leaders trust, providing strategic insights, and creating decision-ready frameworks that support growth and investment readiness."
  },
  {
    id: 5,
    question: "How quickly can you start?",
    answer: "We can typically begin within 1-2 weeks after our initial consultation. For urgent due diligence or fundraising support, we can expedite the onboarding process."
  },
  {
    id: 6,
    question: "What information do you need to get started?",
    answer: "We'll need access to your accounting systems, recent financial statements, current reporting processes, and a brief overview of your pain points. We'll guide you through the specific requirements during our discovery call."
  }
];

export const blogPosts = [
  {
    id: 1,
    title: "The Hidden Cost of Unreliable Financial Data for Growing SaaS Companies",
    excerpt: "Discover how inaccurate metrics can derail your fundraising efforts and what to do about it before your next investor meeting.",
    category: "SaaS Finance",
    readTime: "8 min read",
    date: "2025-01-15",
    slug: "hidden-cost-unreliable-financial-data-saas",
    author: "Venura Consultants",
    tags: ["SaaS", "Metrics", "Fundraising", "Financial Accuracy"],
    metaTitle: "Hidden Cost of Unreliable Financial Data for SaaS",
    metaDescription: "Inaccurate financial metrics derail SaaS fundraising and growth. Learn what to fix before your next investor meeting with proven frameworks.",
    focusKeyword: "unreliable financial data SaaS",
    heroImageAlt: "SaaS financial data accuracy analysis for investor readiness and growth planning"
  },
  {
    id: 2,
    title: "5 Red Flags Investors Look for in Your Financial Due Diligence",
    excerpt: "Learn what makes investors pause during due diligence and how to prepare your financial data room for scrutiny.",
    category: "Due Diligence",
    readTime: "7 min read",
    date: "2025-01-10",
    slug: "investor-due-diligence-red-flags",
    author: "Venura Consultants",
    tags: ["Due Diligence", "Investors", "Fundraising", "Data Room"],
    metaTitle: "5 Investor Due Diligence Red Flags to Avoid",
    metaDescription: "Learn the critical investor due diligence red flags that kill deals. Discover what VCs scrutinize during fundraising and how to fix issues before they cost you.",
    focusKeyword: "investor due diligence red flags",
    heroImageAlt: "Financial due diligence red flags investors examine during SaaS fundraising and acquisition process"
  },
  {
    id: 3,
    title: "How to Reduce Your Month-End Close Time by 50% (Without Hiring More Staff)",
    excerpt: "Practical strategies to streamline your accounting close process, improve accuracy, and free up your team's time.",
    category: "Operational Excellence",
    readTime: "6 min read",
    date: "2025-01-05",
    slug: "reduce-month-end-close-time",
    author: "Venura Consultants",
    tags: ["Accounting", "Process Optimization", "Efficiency", "Automation"],
    metaTitle: "Reduce Month-End Close Time by 50% Without Hiring",
    metaDescription: "Cut your month-end close time in half without adding headcount. Learn proven strategies to streamline financial close processes and boost efficiency.",
    focusKeyword: "reduce month-end close time",
    heroImageAlt: "Finance team implementing automated month-end close processes to reduce closing time and improve accuracy"
  },
  {
    id: 4,
    title: "Building Investor-Ready Financial Reports: A Practical Guide for Founders",
    excerpt: "What metrics matter most to investors and how to present your financial story with clarity and confidence.",
    category: "Reporting",
    readTime: "7 min read",
    date: "2024-12-28",
    slug: "building-investor-ready-financial-reports",
    author: "Venura Consultants",
    tags: ["Reporting", "Investors", "Metrics", "KPIs"],
    metaTitle: "Building Investor-Ready Financial Reports for Founders",
    metaDescription: "Learn how to build investor-ready financial reports that close deals. Discover what VCs scrutinize and how to present your startup's financials professionally.",
    focusKeyword: "investor-ready financial reports",
    heroImageAlt: "Founder preparing investor-ready financial reports and statements for Series A fundraising presentation"
  },
  {
    id: 5,
    title: "The ROI of Financial Process Optimization: Real Numbers from Real Businesses",
    excerpt: "Case studies showing how improved financial processes directly impact EBITDA, margins, and operational efficiency.",
    category: "Case Studies",
    readTime: "7 min read",
    date: "2024-12-20",
    slug: "financial-process-optimization-roi",
    author: "Venura Consultants",
    tags: ["ROI", "Case Studies", "Process Improvement", "Results"],
    metaTitle: "ROI of Financial Process Optimization: Real Numbers",
    metaDescription: "Discover real ROI data from financial process optimization. Learn how businesses achieve 30-40% time savings and 6-12 month payback with automation.",
    focusKeyword: "financial process optimization ROI",
    heroImageAlt: "Business dashboard showing financial process optimization ROI metrics and cost savings from automation implementation"
  },
  {
    id: 6,
    title: "D2C Brands: Master Your Unit Economics Before Scaling",
    excerpt: "Why understanding your true unit economics is critical for sustainable growth in ecommerce and how to get it right.",
    category: "E-commerce",
    readTime: "9 min read",
    date: "2024-12-15",
    slug: "d2c-brands-master-unit-economics-before-scaling",
    author: "Venura Consultants",
    tags: ["D2C", "E-commerce", "Unit Economics", "Scaling"],
    metaTitle: "D2C Unit Economics: Master CAC, LTV & Margins Before Scaling",
    metaDescription: "Learn how D2C brands can master unit economics, optimize CAC, LTV, contribution margins and payback periods to secure funding and achieve profitable growth in 2025.",
    focusKeyword: "D2C unit economics",
    heroImageAlt: "D2C brand unit economics dashboard showing CAC and LTV metrics"
  },
  {
    id: 7,
    title: "Deferred Revenue in SaaS Businesses: A Founder's Guide",
    excerpt: "Understand how deferred revenue impacts your SaaS financials, fundraising prospects, and M&A value.",
    category: "SaaS Finance",
    readTime: "8 min read",
    date: "2024-12-10",
    slug: "deferred-revenue-saas-businesses-founders-guide",
    author: "Venura Consultants",
    tags: ["SaaS", "Deferred Revenue", "M&A", "Valuation"],
    metaTitle: "Deferred Revenue in SaaS: Founder's Guide to RPO & M&A Value",
    metaDescription: "Master deferred revenue, RPO calculations, and M&A negotiations for your SaaS business. Learn ASC 606/IFRS 15 compliance and strategies to maximize valuation.",
    focusKeyword: "deferred revenue SaaS",
    heroImageAlt: "Deferred revenue balance sheet presentation showing liability treatment for SaaS subscriptions"
  },
  {
    id: 8,
    title: "Understanding RPO (Remaining Performance Obligations) in SaaS Valuation",
    excerpt: "Discover how Remaining Performance Obligations provide investors with forward-looking revenue visibility.",
    category: "SaaS Finance",
    readTime: "9 min read",
    date: "2024-12-05",
    slug: "understanding-rpo-remaining-performance-obligations-saas-valuation",
    author: "Venura Consultants",
    tags: ["RPO", "SaaS", "Valuation", "Metrics"],
    metaTitle: "Understanding RPO in SaaS: Complete Guide to Valuation Impact",
    metaDescription: "Master Remaining Performance Obligations (RPO) calculation, accounting standards (ASC 606, IFRS 15, IND AS 115), and strategic presentation to maximize your SaaS valuation.",
    focusKeyword: "RPO SaaS valuation",
    heroImageAlt: "RPO calculation formula showing deferred revenue plus contracted backlog for SaaS companies"
  }
];

export const industries = [
  { name: "SaaS Businesses", icon: "cloud" },
  { name: "Digital Agencies", icon: "briefcase" },
  { name: "D2C/E-commerce", icon: "shopping-cart" },
  { name: "Early-Stage Startups", icon: "rocket" },
  { name: "Fintech & NBFCs", icon: "credit-card" },
  { name: "Manufacturing", icon: "factory" },
  { name: "B2B & B2C", icon: "building" },
  { name: "Construction", icon: "hard-hat" }
];

export const problemsSolved = [
  "Unreliable financial numbers",
  "Unclear business risks",
  "Inefficient approval processes",
  "Scattered information across tools",
  "Delayed month-end closes",
  "Unclear profitability by product/customer",
  "Late discovery of operational issues",
  "Inconsistent cash flow tracking",
  "Time spent correcting recurring issues",
  "Reports that don't provide clear picture",
  "Routine work dependent on manual follow-ups"
];